import { GUILD_EVENTS_SCHEDULE_CONFIG } from "@/core/guild-events/types"

const timezone = GUILD_EVENTS_SCHEDULE_CONFIG.timezone
const calendarParts = new Intl.DateTimeFormat("en-GB", {
  timeZone: timezone,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
})

export const guildJoinCalendarDate = (value: Date | string): string => {
  const parts = calendarParts.formatToParts(new Date(value))
  const part = (type: string) =>
    parts.find((entry) => entry.type === type)?.value
  return `${part("year")}-${part("month")}-${part("day")}`
}

export const formatGuildJoinDate = (value: Date | string): string => {
  const [year, month, day] = guildJoinCalendarDate(value).split("-")
  return `${day}.${month}.${year}`
}

const calendarDayNumber = (date: string): number => {
  const year = Number(date.slice(0, 4))
  const month = Number(date.slice(5, 7))
  const day = Number(date.slice(8, 10))
  return Math.floor(Date.UTC(year, month - 1, day) / 86_400_000)
}

export const guildJoinTenureDays = (
  value: Date | string,
  now = new Date(),
): number =>
  Math.max(
    0,
    calendarDayNumber(guildJoinCalendarDate(now)) -
      calendarDayNumber(guildJoinCalendarDate(value)),
  )

export const parseGuildJoinCalendarDate = (value: string): Date | null => {
  if (
    !/^(?:[1-9]\d{3})-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])$/.test(value)
  ) {
    return null
  }
  const year = Number(value.slice(0, 4))
  const month = Number(value.slice(5, 7))
  const day = Number(value.slice(8, 10))
  const utc = new Date(Date.UTC(year, month - 1, day))
  if (
    utc.getUTCFullYear() !== year ||
    utc.getUTCMonth() + 1 !== month ||
    utc.getUTCDate() !== day
  ) {
    return null
  }
  const noonUtc = new Date(Date.UTC(year, month - 1, day, 11))
  const berlinTime = new Intl.DateTimeFormat("en-GB", {
    timeZone: timezone,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(noonUtc)
  const time = (type: string) =>
    Number(berlinTime.find((entry) => entry.type === type)?.value)
  const difference =
    (time("hour") - 12) * 3_600_000 +
    time("minute") * 60_000 +
    time("second") * 1_000
  return new Date(noonUtc.getTime() - difference)
}
